import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import TableCell from '../TableCell/TableCell';
// Component.
// -----------------------------------------------------------------------------
const TableHeader = forwardRef(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableCell, { header: true, ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableHeader.displayName = 'TableHeader';
export default TableHeader;
//# sourceMappingURL=TableHeader.js.map